import { useMemo } from "react";

import Table from "ds/components/Table";
import { ManagedUserGroup } from "types/generated";
import TableWrapper from "ds/components/Table/Wrapper";
import TableSkeleton from "ds/components/Table/Skeleton";
import { TableColumnsState } from "ds/components/Table/useTableStore/types";
import useSortState from "components/Filters/useSortState";

import IdpGroupTableHead from "./Head";
import IdpGroupTableBody from "./Body";
import { useIdpGroupTableStore } from "./useIdpGroupTableStore";
import { IDP_GROUP_COLUMN_ID, IdpGroupFilterItemKeys } from "../constants";
import { sortGroups } from "./sort";

type IdpGroupTableProps = {
  groups: Array<ManagedUserGroup>;
  loadingContent?: boolean;
};

type IdpGroupTableState = TableColumnsState<IDP_GROUP_COLUMN_ID>;

const IdpGroupTable = ({ groups, loadingContent }: IdpGroupTableProps) => {
  const visibleColumnsIds = useIdpGroupTableStore(
    (state: IdpGroupTableState) => state.columnsOrder.visible
  );

  const { sortState } = useSortState();

  const sortedGroups = useMemo(
    () => sortGroups(groups, sortState.sortKey as IdpGroupFilterItemKeys, sortState.sortDirection),
    [groups, sortState.sortKey, sortState.sortDirection]
  );

  // Determine number of skeleton rows to display when loading
  const skeletonRowsPerPage = groups.length || 10;

  return (
    <TableWrapper hasPagination={false}>
      <Table ariaLabel="Identity Provider Group Mapping table">
        <IdpGroupTableHead />

        {loadingContent ? (
          <TableSkeleton columnIds={visibleColumnsIds} rowsPerPage={skeletonRowsPerPage} />
        ) : (
          <IdpGroupTableBody groups={sortedGroups} />
        )}
      </Table>
    </TableWrapper>
  );
};

export default IdpGroupTable;
